module.exports = __webpack_public_path__ + "img/case62.54d77d23.png";